/* eslint-disable */
export const printError = (error: any, origin: string = '') => {
  try {
    console.info(`<====ERROR-${origin}====>`, JSON.stringify(error))
    console.error('<=====EM====>', JSON.stringify(error?.message))
    console.error('<=====ES====>', JSON.stringify(error?.stack))
    console.error('<=====EN====>', JSON.stringify(error?.name))
  } catch (error) {
    return false
  }
}
